import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import PersonTypeList from "./PersonTypeList";

export default {
  list: PersonTypeList,
  icon: PeopleAltIcon,
};
